import { TriStateCheckbox } from 'primereact/tristatecheckbox';
import React from 'react';
import { SegmentEventTypes } from '../../data/tracking';
import Analytics from '../../utils/Analytics';
import LabelWrapper from '../LabelWrapper.component';

/**
 * Translate value from TriStateCheckbox component.
 * 	`true`  => 1 (checked)
 * 	`false` => 0 (unchecked)
 * 	`null`  => 2 (undetermined)
 *
 * @param {boolean|null} value
 * @returns {number}
 */
const convertFromTriStateValue = value => {
	if (value === true) {
		return 1;
	} else if (value === false) {
		return 0;
	}

	return 2;
};

/**
 * Translate value for TriStateCheckbox component.
 *  `0` => false (unchecked)
 * 	`1` => true (checked)
 * 	`2` => null (undetermined)
 *
 * @param {boolean|null} value
 * @returns {number}
 */
const convertToTriStateValue = value => {
	if (value === 0) {
		return false;
	} else if (value === 1) {
		return true;
	}

	return null;
};

export const WrappedTriStateCheckbox = props => {
	const { value, onChange, dataqa = 'common' } = props;

	const onTriStateCheckboxChange = e => {
		Analytics.trackSegmentEvent({
			trackingData: {
				field_type: 'tristatecheckbox',
				field_name_dataqa: `ui-tristatecheckbox-${dataqa}`,
				field_value: e.value,
			},
			eventType: SegmentEventTypes.UserInteraction,
		});

		if (onChange) {
			onChange({
				value: convertFromTriStateValue(e.value),
			});
		}
	};

	return (
		<div className="common-ui-tristatecheckbox">
			<TriStateCheckbox
				{...props}
				value={convertToTriStateValue(value)}
				dataqa={`ui-tristatecheckbox-${dataqa}`}
				onChange={onTriStateCheckboxChange}
			/>
		</div>
	);
};

WrappedTriStateCheckbox.defaultProps = {
	...TriStateCheckbox.defaultProps,
	value: null,
};

export const WrappedTriStateCheckboxWithLabel = LabelWrapper(
	WrappedTriStateCheckbox
);
